import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);  // scroll to top
    AOS.refresh();          // refresh AOS animations
  }, [pathname]);

  return null;
}

export default ScrollToTop;
